import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5a560edc&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=5a560edc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a560edc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a560edc')) {
      api.createRecord('5a560edc', component.options)
    } else {
      api.reload('5a560edc', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=5a560edc&scoped=true", function () {
      api.rerender('5a560edc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/consumer/consumerScan_budget_report/form/detail.vue"
export default component.exports